export default __webpack_public_path__ + "static/media/Head.9a3ede3a.svg";